module.exports = __webpack_public_path__ + "8d6871917dd571682b3c533625d8b288.svg";